import * as React from 'react';

const styles = require('./columns.css');

interface IColumnsProps<T> {
  items: T[];
  columns: number;
  renderItem(item: T): React.ReactNode;
}

function splitToColumns<T>(items: T[], columns: number) {
  const result = [];
  let start = 0;

  for (let i = columns; i > 0; i--) {
    const end = start + Math.ceil((items.length - start) / i);
    const column = items.slice(start, end);

    result.push(column);
    start = end;
  }

  return result;
}

export class Columns<T> extends React.PureComponent<IColumnsProps<T>> {
  public render() {
    return (
      <div className={styles['columns']}>
        {splitToColumns(this.props.items, this.props.columns).map((column, index) => (
          <div key={index} className={styles['column']}>
            {column.map(this.props.renderItem)}
          </div>
        ))}
      </div>
    );
  }
}
